import { globalCss } from '@stitches/react'
import { useTutorialEnabled } from 'src/components/organisms/OnboardingTutorial/useTutorialEnabled'

export const globalStyle = globalCss({
  'html, body, body > div:first-child, div#root_container, div#root_container > div': {
    height: '100%',
  },
  body: {
    backgroundColor: '$backgroundPrimary !important',
  },
})

const globalStylesTutorial = globalCss({
  body: {
    pointerEvents: 'auto !important',
  },
  '.onboarding-tutorial': {
    'div[data-flora="modal-content"]': {
      width: '324px',
    },
    '[data-flora="modal-content"]': {
      '> header': {
        padding: '16px',
      },
      '> button[aria-label="Fechar"]': {
        width: '24px',
        height: '24px',
      },
      '> div[data-flora="modal-body"]': {
        padding: '0 16px 16px 16px',
      },
      '> footer': {
        padding: '16px',
      },
    },
  },
})

export const GlobalStylesTutorial = () => {
  const isTutorialEnabled = useTutorialEnabled()

  isTutorialEnabled && globalStylesTutorial()
  return null
}
